<template>
	<div class="basic-container popup">
		<div class="popup-buyer-area">
			<section>
				<h4>항목 구분 표</h4>
				<table class="online-report-section-table" cellspacing="0" cellpadding="0">
					<tr>
						<th class="col-w15">구분</th>
						<th class="col-w15">항목</th>
						<th class="col-w70">내용</th>
					</tr>
					<tr>
						<td class="text-center" rowspan="4">오프라인</td>
						<td class="text-center">회의비</td>
						<td>
							OKTA회원이 바이어와의 미팅을 위해 필요한 식비,음료비 일체<br />
							<span class="color-red">※ 주류는 지원불가</span>
						</td>
					</tr>
					<tr>
						<td class="text-center">교통비</td>
						<td>
							OKTA회원이 미팅을 위해 이동 시 사용한 이동경비 일체<br />(항공, 버스, 지하철, 택시 등)<br />
							<span class="color-red">※ 항공지원은 지역TP별 지원가능여부가 다르기에 반드시 사전에 확인이 필수 !!</span>
						</td>
					</tr>
					<tr>
						<td class="text-center">임차비</td>
						<td>
							OKTA회원이 미팅을 위해 장소, 기기 등을 임대하는 비용 일체<br />
							(회의실, 음향기기, 조명기기, 영상기기 등)
						</td>
					</tr>
					<tr>
						<td class="text-center">기타</td>
						<td>
							위에 제시되지 않는 항목 일체<br />
							<span class="color-red"
								>▶︎ 지원여부에 대해 해당 TP에 사전 확인 절차 필수!<br />
								&nbsp;각 TP와 OKTA사무국에서 불인정하는 경우 인정 불가</span
							>
						</td>
					</tr>
					<tr>
						<td class="text-center">온라인</td>
						<td class="text-center">회의비</td>
						<td>
							지역별 온라인 바이어 미팅 기준단가표 적용<br />
							<span class="color-red">▶ 기준단가표는 왼쪽 카테고리 게시판에서 확인 가능<br /></span>
							<span class="color-red">▶ 기준단가표 외 비용은 정산 불가</span>
						</td>
					</tr>
				</table>
			</section>
		</div>
	</div>
</template>

<script>
export default {
	title: '바이어보고서 팝업',
	name: 'PopupBuyer',
	props: [],
	components: {},
	data: function() {
		return {};
	},
	watch: {},
	created() {},
	computed: {},

	methods: {},
};
</script>

<style scoped></style>
